import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // Start at 13 minutes and 11 seconds
  const [timeLeft, setTimeLeft] = useState(13 * 60 + 11);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 13 * 60 + 11); // Reset if it hits 0 for demo purposes
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 w-full bg-red-700 text-white py-3 px-4 text-center font-bold text-sm md:text-base shadow-md flex items-center justify-center gap-2 animate-pulse" data-id="element-29">
      <Clock className="w-5 h-5" data-id="element-30" />
      <span data-id="element-31">
        ⏳ OFERTA EXPIRA EN: {formatTime(timeLeft)} | 🟢 CUPOS LIMITADOS
      </span>
    </div>;
}